import { useState } from "react";
import { Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import ExcelJS from "exceljs";

export const ExportExcel = ({ participantes, loading = false }) => {
  const [exporting, setExporting] = useState(false);

  const exportToExcel = async () => {
    setExporting(true);
    try {
      const workbook = new ExcelJS.Workbook();
      workbook.creator = "Sistema de Participantes";
      workbook.lastModifiedBy = "Sistema de Participantes";
      workbook.created = new Date();
      workbook.modified = new Date();

      const sheet = workbook.addWorksheet("Participantes", {
        properties: { tabColor: { argb: "FF3366CC" } },
      });

      // Encabezados exactos
      const headers = [
        "Item",
        "Nombres y Apellidos Completos",
        "Identificacion",
        "tipo de documento",
        "telefono",
        "email",
        "Sexo",
        "EDAD",
        "año de nacimiento",
        "Departamento de Residencia",
        "Lugar de Residencia (Indique Dirección y nombre del municipio o vereda)",
        "Cohorte",
        "Activo/a (SI/NO)",
        "Autorizacion tratamiento de datos",
        "Etnia",
        "De las siguientes instancias de participación a cuáles pertenece",
        "Módulo 1", "Fecha",
        "Módulo 2", "Fecha3",
        "Módulo 3", "Fecha4",
        "Módulo 4", "Fecha5",
        "Módulo 5", "Fecha6",
        "Autónoma 1", "Fecha7",
        "Autónoma 2", "Fecha8",
        "Autónoma 3", "Fecha9",
        "Autónoma 4", "Fecha10",
        "Autónoma 5", "Fecha11",
        "Autónoma 6", "Fecha12",
        "Certificado",
        "Observación Matriculado(a) en"
      ];

      sheet.addRow(headers);

      // Estilo encabezado
      headers.forEach((_, index) => {
        const cell = sheet.getRow(1).getCell(index + 1);
        cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF3366CC" } };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });

      participantes.forEach((p, index) => {
        const rowData = [
          index + 1,
          p.nombre_matriculado,
          p.identificacion,
          p.tipo_documento,
          p.telefono,
          p.email,
          p.sexo === 1 ? "Hombre" : "Mujer",
          p.edad,
          p.fecha_nacimiento,
          p.departamento || "",
          p.municipio || "",
          p.cohorte,
          p.activo,
          p.tratamiento_datos,
          p.etnico || "Ningún grupo étnico",
          p.nombre || "Ninguna"
        ];

        // Orden fijo de los módulos según oid_tematica
        const tematicasOrden = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
        const asistenciasMap = {};
        p.children?.forEach((a) => {
          asistenciasMap[a.oid_tematica] = {
            participa: a.participa === 1 ? "Si" : "No",
            fecha: a.fecha ? new Date(a.fecha).toISOString().split("T")[0] : ""
          };
        });

        tematicasOrden.forEach((id) => {
          rowData.push(asistenciasMap[id]?.participa || "No");
          rowData.push(asistenciasMap[id]?.fecha || "");
        });

        rowData.push(p.certificado);
        rowData.push(p.observacion || "");

        sheet.addRow(rowData);
      });

      // Ancho de columnas
      sheet.columns.forEach((col, i) => {
        col.width = headers[i].length < 15 ? 15 : headers[i].length + 5;
      });

      // Bordes
      sheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });

      // Descargar archivo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `participantes_${new Date().toISOString().split("T")[0]}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error al exportar:", error);
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button
      type="text"
      icon={<FontAwesomeIcon icon={faFileExcel} />}
      onClick={exportToExcel}
      loading={loading || exporting}
      disabled={participantes.length === 0}
      style={{
        minWidth: 180,
        backgroundColor: "#107C41",
        borderColor: "#107C41",
        color: "#fff",
        fontWeight: "bold",
        borderRadius: 6,
      }}
    >
      {exporting ? "Exportando..." : "Exportar Excel"}
    </Button>
  );
};

export default ExportExcel;
